import { request } from './index';

export type LessonType = {
  id: number;
  name: string;
};

export async function fetchLessons<LessonType>(): Promise<LessonType> {
  return await request(true, {
    url: `/lessons/lessons`
  });
}
